export const educationRecognitionOptions = [
  'None',
  'Australian qualification',
  'Australian equivalent',
  'International',
];
